import { render, staticRenderFns } from "./GetInTouchSection.vue?vue&type=template&id=46d40dbc&"
import script from "./GetInTouchSection.vue?vue&type=script&lang=js&"
export * from "./GetInTouchSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\marci\\Desktop\\majorel-china-static\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46d40dbc')) {
      api.createRecord('46d40dbc', component.options)
    } else {
      api.reload('46d40dbc', component.options)
    }
    module.hot.accept("./GetInTouchSection.vue?vue&type=template&id=46d40dbc&", function () {
      api.rerender('46d40dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/GetInTouchSection.vue"
export default component.exports